export default class InputMask {
    constructor(input) {
        this.init = () => {
            // add placeholder
            this.input.placeholder = this.generatePlaceholder();
            // validate mask
            this.input.addEventListener("keydown", this._validateMask);
            this.input.addEventListener("keyup", this._validateMask);
            this.input.addEventListener("keypress", this._validateKey);
        };
        this.generateRegex = () => {
            return '\\d{' + this.maxCharacter + '}';
        };
        this.generatePlaceholder = () => {
            return this.maskString.replace(/\d/g, '#');
        };
        this._validateMask = (e = null) => {
            // ignore if more than limit
            if (this.input.value.length > this.maxCharacter) {
                this.input.value = this.input.value.substring(0, this.maxCharacter);
            }
        };
        this._validateKey = (e = null) => {
            const charCode = (e.which) ? e.which : e.keyCode;
            // only allow number
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                e.stopImmediatePropagation();
                e.preventDefault();
                return false;
            }
            return true;
        };
        this.input = input;
        // get mask
        this.maskString = input.getAttribute("data-input-mask");
        // ignore if no mask rule
        if (!this.maskString || this.maskString.length <= 0) {
            this.init = () => { };
        }
        // update max character allowed
        this.maxCharacter = this.maskString.match(/\d/g).length;
        // add maxlength
        this.input.maxLength = this.maxCharacter;
    }
}
